import { message } from 'antd';

export const successMsg = (msg) => {
  message.success(msg);
};

export const errorMsg = (msg) => {
  message.error(msg);
};
